import React from 'react';
import type { Card } from '../../../../games/van-life/van-life';

export const SUIT_COLOR: Record<string, string> = {
  Green: '#22C55E',
  Blue:  '#60A5FA',
  Tan:   '#D97706',
  Wild:  '#FBBF24',
};

export const SUIT_BG: Record<string, string> = {
  Green: 'rgba(34,197,94,0.12)',
  Blue:  'rgba(96,165,250,0.12)',
  Tan:   'rgba(217,119,6,0.12)',
  Wild:  'rgba(251,191,36,0.15)',
};

export function suitLabel(suit: string): string {
  return suit === 'Wild' ? 'W' : suit[0];
}

interface CardFaceProps {
  card: Card;
  size?: 'sm' | 'md' | 'lg';
  faceDown?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  highlight?: boolean;
}

export function CardFace({ card, size = 'md', faceDown, onClick, disabled, highlight }: CardFaceProps) {
  const dims = {
    sm: 'w-10 h-14 text-sm',
    md: 'w-14 h-20 text-base',
    lg: 'w-20 h-28 text-2xl',
  }[size];

  if (faceDown) {
    return (
      <div className={`${dims} rounded-lg border-2 border-gray-600 bg-gray-800 flex items-center justify-center`}>
        <span className="text-gray-600 text-xl">?</span>
      </div>
    );
  }

  const color = SUIT_COLOR[card.suit] ?? '#999';
  const bg    = SUIT_BG[card.suit]   ?? 'rgba(0,0,0,0.1)';

  return (
    <button
      onClick={onClick}
      disabled={disabled || !onClick}
      className={`${dims} rounded-lg border-2 flex flex-col items-center justify-center gap-0.5
        transition-all duration-150 font-bold
        ${onClick && !disabled ? 'cursor-pointer hover:scale-105 hover:shadow-lg active:scale-95' : 'cursor-default'}
        ${highlight ? 'ring-2 ring-yellow-400 ring-offset-1 ring-offset-gray-900' : ''}
        ${disabled ? 'opacity-40' : 'opacity-100'}`}
      style={{ borderColor: color, background: bg, color }}
    >
      <span className="leading-none" style={{ fontSize: size === 'lg' ? '1.5rem' : size === 'md' ? '1.1rem' : '0.85rem' }}>
        {suitLabel(card.suit)}
      </span>
      <span className="leading-none font-black" style={{ fontSize: size === 'lg' ? '2rem' : size === 'md' ? '1.4rem' : '1rem' }}>
        {card.rank}
      </span>
    </button>
  );
}
